import React, { ReactNode } from 'react';
import { PaymentSummaryRow } from './PaymentSummaryRow';
import './PaymentSummaryRow.scss';

interface Props {
  label: ReactNode;
  value: ReactNode;
}

export const PaymentSummaryTaxRow: React.FC<Props> = ({ label, value }) => {
  return (
    <PaymentSummaryRow
      label={label}
      tooltip={
        <>
          Duties and taxes will be calculated at checkout, where applicable. Learn more about Duties
          and Taxes{' '}
          <a
            className="PaymentSummaryTaxRow__faq-link"
            href="https://help.modaoperandi.com/hc/en-us/articles/211521823-Taxes-Duties"
            rel="noopener
            noreferrer"
            target="_blank"
          >
            in our FAQs
          </a>
          .
        </>
      }
      value={value}
    />
  );
};
